export default __webpack_public_path__ + "static/media/empty-containers.7141e6b0.svg";